module.exports = __webpack_public_path__ + "files/5ce245c94d259f79e3d8b3fe9b648b47.png";